import axios from '@liepin/cnpm-js-axios-fe';
import { createBrowserHistory } from 'history';

// 统一规范，使用 __LP_VERSION
window.__FE_CLIENT_ID = '40247';
// window.__LP_CLIENT_ID
window.__FE_VERSION = '20220720';

const history = createBrowserHistory();
const ajax = axios.create({
  //baseURL: '/api/',
  timeout: 5000,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded',
    //'Cache-Control': 'no-cache',
  },
  transformRequest: [
    data => {
      if (data) {
        return Object.keys(data).reduce((result, val) => result += `${encodeURIComponent(val)}=${encodeURIComponent(data[val])}&`, '').replace(/&$/, '');
      } else {
        return data;
      }
    }
  ]
});

let cloneGet = ajax.get;
ajax.get = (url, data) => cloneGet(url, { params: data });

ajax.interceptors.response.use(
  response => {
    const { flag, msg, code } = response.data
    if (flag !== 1) {
      switch (code) {
        case 302:
        case 301:
        case 404:
          history.push('/notFound404');
          break;
        case 500:
        default:
      }
      //msg && message.warning(msg, 8);
    }
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
)

export default ajax;